import {NgModule} from '@angular/core';
import {SettingsComponent} from './settings.component';

@NgModule({
    declarations: [
        SettingsComponent,
    ]
})
export class SettingsModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/settings/settings.module.ts